<template>
    <div v-if="tableStaticDataList.length > 0" class="staticTables">
        <StaticTable v-for="item in tableStaticDataList" :key="item.name" :list="item.data"
                     :name="item.name" />
    </div>
</template>

<script>
    import { ProductType, ReceiveType } from '../constant';
    import { getTotalCount, toThousands } from '../utils';
    import StaticTable from './StaticTable';

    export default {
        components:{
            StaticTable,
        },
        props:['originData'],
        name: 'StaticTableList',
        data() {
            return {
            }
        },
        computed:{
            tableStaticDataList() {
                if(this.originData && this.originData.length > 0){
                    const tableStaticDataList = [];
                    ProductType.map(product => {
                        const chartDailyDataListItem = [];
                        let chartDailyDataListItemSort = [];
                        ReceiveType.map(seriesName => {
                            const data = this.originData.filter(item => item['物资类型'] == product.value)
                            const typeData = data.filter(item => item['接收单位类型'] == seriesName.value)
                            const total = getTotalCount(data)
                            const typeTotal = getTotalCount(typeData)
                            if (typeTotal && typeTotal / total > 0.01) {
                                chartDailyDataListItem.push({
                                    '名称': seriesName.text,
                                    '数量': toThousands(typeTotal),
                                    'total': typeTotal,
                                    '占比': (total ? ((typeTotal / total) * 100).toFixed(2) : 0) + ' %',
                                })
                            }
                            chartDailyDataListItemSort = chartDailyDataListItem.sort((a, b) => b.total - a.total)
                        })
                        tableStaticDataList.push({
                            name: product.value,
                            data: chartDailyDataListItemSort
                        })
                    })
                    return tableStaticDataList
                }else{
                    return []
                }
            },
        },
        methods: {

        }
    }
</script>

<style scoped>
    .staticTables {
        width: 98%;
        margin: 1%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
    }
</style>
